import React, {FC} from 'react';
import './styles.scss';

import bonus from '../../../assets/careers/benefits/bonus.svg';
import coffee from '../../../assets/careers/benefits/coffee.svg';
import daysOff from '../../../assets/careers/benefits/day-off.svg';
import flex from '../../../assets/careers/benefits/flex.svg';
import luckyCarrot from '../../../assets/careers/benefits/lucky-carrot.svg';
import insurance from '../../../assets/careers/benefits/insurance.svg';
import referral from '../../../assets/careers/benefits/referral.svg';
import reward from '../../../assets/careers/benefits/reward.svg';
import salary from '../../../assets/careers/benefits/salary.svg';
import stock from '../../../assets/careers/benefits/stock.svg';
import teambuilding from '../../../assets/careers/benefits/teambuilding.svg';
import training from '../../../assets/careers/benefits/training.svg';
import {Col, Row} from 'react-bootstrap';

const Benefit = () => {
  const benefits = [
    {name: 'Medical Insurance', img: insurance},
    {name: 'Annual Salary Review', img: salary},
    {name: 'Days Off', img: daysOff},
    {name: 'Teambuilding and Corporate Events', img: teambuilding},
    {name: 'Flexible Working Schedule', img: flex},
    {name: 'Training Package', img: training},
    {name: 'Stock Options', img: stock},
    {name: 'Annual Bonus', img: bonus},
    {name: 'Lucky Carrot', img: luckyCarrot},
    {name: 'Tea, Coffee and Refreshments', img: coffee},
    {name: 'Reward Systems', img: reward},
    {name: 'Staff Referral Program', img: referral},
  ];

  return (
    <div className="benefits-section">
      <div className="text-center mx-auto benefits">
        <div className="badge-title mt-0">Perks and Benefits</div>
        <h2 className="page-title d-block">Benefits of working at Hexact</h2>
        <p>
          Aside from the potential to join the movement and contribute to the global future of data and AI. At Hexact we
          value our employees financially, physically, and emotionally.
        </p>
      </div>
      <Row className="benefits-container">
        {benefits.map(item => (
          <Col xs={6} md={4} lg={3} className="benefit-item">
            <img src={item.img} alt={item.name} />
            <h3>{item.name}</h3>
          </Col>
        ))}
      </Row>
    </div>
  );
};
export default Benefit;
